
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { PATH } from '../../config';
import Loading from 'app/components/MatxLoading'; 

const RoleBasedGuard = ({ children, allowedRoles }) => {
  const { user, loginLoading } = useSelector((state) => state.user);

  if (loginLoading) {
    return <Loading />;
  }

  
  if (!user) {
    return <Navigate to={PATH.LOGIN} replace />;
  }

  const isAuthorized = user && allowedRoles.includes(user.userType);

  if (isAuthorized) {
    return <>{children}</>;
  } else {
    alert("Access Denied: You do not have permission to view this page.");
    return <Navigate to={PATH.DASHBOARD} replace />;
  }

};

export default RoleBasedGuard;